import { Trans } from '@bonanza-social/i18n';
import { Box, Image, Text } from '@bonanza-social/moonlight';
import { useNavigation } from '@bonanza-social/navigation';
import { memo, useCallback } from 'react';

function InboxMarketingTurnedOffMessages() {
  const navigation = useNavigation();

  const handlePress = useCallback(() => {
    navigation.popToTop();
    navigation.navigate('Notifications');
  }, [navigation]);

  return (
    <Box alignItems="center" paddingHorizontal="space-600">
      <Image
        name="common.NotificationBell"
        width={80}
        height={80}
        marginVertical="space-600"
      />
      <Box gap="space-400">
        <Text
          variant="h4"
          color="darkSurfacePrimary"
          locNS="inbox"
          locKey="turnedOffMarketingTitle"
          textAlign="center"
        />
        <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
          <Trans
            ns="inbox"
            i18nKey="turnedOffMarketingDescription"
            components={{
              span: (
                <Text
                  variant="body-s"
                  color="darkSurfacePrimary"
                  onPress={handlePress}
                  underline
                />
              ),
            }}
          />
        </Text>
      </Box>
    </Box>
  );
}

export default memo(InboxMarketingTurnedOffMessages);
